import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { timeFromNow } from '../utils/date';
import { asyncPopulateUsersAndThreads } from '../states/shared/action';
import MarkdownParser from '../components/utilities/MarkdownParser';
import LikeDislikeButton from '../components/utilities/LikeDislikeButton';
import CommentCount from '../components/utilities/CommentCount';
import HastagIcon from '../components/icons/HastagIcon';

export default function ThreadsPage() {
  const { threads = [], authUser } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [threadList, setThreadList] = useState([]);

  useEffect(() => {
    dispatch(asyncPopulateUsersAndThreads());
  }, [dispatch]);

  useEffect(() => {
    const getMyThread = threads?.filter(
      ({ ownerId }) => ownerId === authUser.id
    );
    setThreadList(getMyThread);
  }, [authUser, threads]);

  return (
    <section>
      {threads?.length ? (
        <div className="w-full">
          <h1 className="text-2xl font-bold">My Threads</h1>
          <ul>
            {threadList?.length ? (
              threadList.map((thread) => (
                <li
                  key={thread.id}
                  className="flex flex-col gap-y-3 mt-8 rounded-lg bg-zinc-100 dark:bg-zinc-900/50 px-6 py-4">
                  <div className="text-zinc-500 dark:text-zinc-400 font-semibold flex gap-x-2 items-center -mb-1">
                    <HastagIcon />
                    {thread.category}
                  </div>
                  <Link
                    to={`/detail/${thread.id}`}
                    className="text-2xl font-medium lg:font-semibold hover:text-cyan-500 dark:hover:text-cyan-600 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-cyan-500 dark:focus-visible:outline-cyan-600 rounded-md">
                    {thread.title}
                  </Link>
                  <MarkdownParser
                    content={thread?.body}
                    className="line-clamp-2"
                  />
                  <div className="text-sm">{timeFromNow(thread.createdAt)}</div>
                  <div className="flex gap-x-6 mt-1">
                    <LikeDislikeButton
                      likeCount={thread?.upVotesBy?.length}
                      dislikeCount={thread?.downVotesBy?.length}
                    />
                    <CommentCount count={thread?.totalComments} />
                  </div>
                </li>
              ))
            ) : (
              <p className="mt-8">No threads yet.</p>
            )}
          </ul>
        </div>
      ) : (
        <div>Loading</div>
      )}
    </section>
  );
}
